<template>
    <div class="dialog_qrcode">
        <div class="dialog">
            <img class="qrcode" src="../assets/qrcode_user.png" />
            <div class="close" @click="close"></div>
        </div>
    </div>
</template>

<script> 

export default {
    components: {},
    data() {
        return {
            
        }
    },
    created() {

    },
    mounted() {

    },
    methods: {
        close(){
            this.$emit('close');
        }
    }
};
</script>
<style scoped lang="scss">
$s1024: 1;
$s750: 1.4;
.dialog_qrcode {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 100;
    background: rgba(0, 0, 0, 0.8);
    .dialog {
        width: 3.74rem;
        height: 3.34rem;
        background: url(../assets/dialog_bg0.png) no-repeat center center;
        background-size: contain;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        z-index: 1;
        @media screen and (max-width: 1024px) {
            width: (3.74rem * $s1024);
            height: (3.34rem * $s1024);
        }
        @media screen and (max-width: 750px) {
            width: (3.74rem * $s750);
            height: (3.34rem * $s750);
        }
        .close {
            width: 0.66rem;
            height: 0.66rem;
            position: absolute;
            right: 0;
            top: 0;
            cursor: pointer;
            @media screen and (max-width: 1024px) {
                width: (0.66rem * $s1024);
                height: (0.66rem * $s1024);
            }
            @media screen and (max-width: 750px) {
                width: (0.66rem * $s750);
                height: (0.66rem * $s750);
            }
        }
        .qrcode {
            width: 1.57rem;
            height: 1.57rem;
            position: absolute;
            left: 1.09rem;
            top: 0.77rem;
            border-radius: 0.2rem;
            background: #fff;
            @media screen and (max-width: 1024px) {
                width: (1.57rem * $s1024);
                height: (1.57rem * $s1024);
                left: (1.09rem * $s1024);
                top: (0.77rem * $s1024);
                border-radius: (0.2rem * $s1024);
            }
            @media screen and (max-width: 750px) {
                width: (1.57rem * $s750);
                height: (1.57rem * $s750);
                left: (1.09rem * $s750);
                top: (0.77rem * $s750);
                border-radius: (0.2rem * $s750);
            }
        }
    }
}
</style>